import { string } from "prop-types";

import FnrSlides from "UI/FnrSlides";

import ActiveState from "./ActiveState";
import InactiveState from "./InactiveState";
import { useIsActive } from "./stateHooks";

const buttonDisplayConfig = [
  { key: "inactive", value: InactiveState },
  { key: "active", value: ActiveState },
];

const ButtonDisplay = ({ color }) => {
  const isActive = useIsActive();

  return (
    <FnrSlides
      activeKey={isActive ? "active" : "inactive"}
      color={color}
      components={buttonDisplayConfig}
      variant="subtle"
    />
  );
};

ButtonDisplay.propTypes = { color: string };

export { ButtonDisplay };
